import { Outlet, createFileRoute } from '@tanstack/react-router';

import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';

export const Route = createFileRoute('/$organizationName/pdf/$pdfVersionNodeId/settings')({
  component: PDFSettingsLayout,
});

function PDFSettingsLayout() {
  return (
    <SettingsPageLayout hideSeparator>
      <Outlet />
    </SettingsPageLayout>
  );
}
